var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M41 10H25v28h16a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32 15h7v3h-7zm0 10h7v3h-7zm0 5h7v3h-7zm0-10h7v3h-7zm-7-5h5v3h-5zm0 10h5v3h-5zm0 5h5v3h-5zm0-10h5v3h-5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E7D32",
    d: "M27 42 6 38V10l21-4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m19.129 31-2.411-4.561c-.092-.171-.186-.483-.284-.938h-.037c-.046.215-.154.541-.324.979L13.652 31H9.895l4.462-7.001L10.274 17h3.837l2.001 4.196c.156.331.296.725.42 1.179h.04c.078-.271.224-.68.439-1.22L19.237 17h3.515l-4.199 6.939 4.316 7.059h-3.74V31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4e8bb2f4.svg";
export { ForwardRef as ReactComponent };